// extracted by mini-css-extract-plugin
module.exports = {"purchaseLimitContainer":"ProductPurchase_purchaseLimitContainer__HoYdt","purchaseLimitNote":"ProductPurchase_purchaseLimitNote__H1eQV"};